import { expValNoExposure } from '@confluence/feature-experiments';

export const useLivePageInviteNudgeV2Eligible = () => {
	return {
		isEligible:
			expValNoExposure('fix_live_pages_invite_nudge', 'cohort', 'control') === 'experiment',
	};
};
